import React from 'react';

import { StyledWishlistButton } from './WishlistButton.styles';

import { WishlistButtonProps } from './WishlistButton.types';

import { colors } from '../../../';
import Heart from '../../../assets/icons/Heart';

const WishlistButton = ({
  skuKey,
  onClick,
  customAddToWishlistMsg,
  customAddedToWishlistMsg,
  customRemoveFromWishlistMsg,
  isIconOnly = false,
  isActive,
  componentClassname = 'wishlist-button',
  customClassnames = '',
  customStyle = '',
  ...props
}: WishlistButtonProps) => {
  const removeMsg = customRemoveFromWishlistMsg || 'Remove from wishlist';
  const addedMsg = customAddedToWishlistMsg || 'Added to wishlist';
  const addMsg = customAddToWishlistMsg || 'Add to wishlist';

  return (
    <StyledWishlistButton
      className={`${componentClassname} ${customClassnames}`}
      aria-label={isIconOnly ? (isActive ? removeMsg : addMsg) : ''}
      data-skukey={skuKey}
      data-qa="wishlist-button"
      onClick={onClick}
      customStyle={customStyle}
      {...props}
    >
      <Heart
        color={isActive ? colors.red : colors.gray60}
        width={19}
        height={17}
      />
      {!isIconOnly ? (
        <span className={`${componentClassname}__label`}>
          {isActive ? addedMsg : addMsg}
        </span>
      ) : null}
    </StyledWishlistButton>
  );
};
WishlistButton.displayName = 'WishlistButton';

export default WishlistButton;
